import { ChangeEvent, useState } from 'react';
import { trackingNuvemDomainsSearch } from 'domains/Configurations/Domains/tracking';

export function useSearchDomain(initialSearchQuery?: string) {
  const [inputValue, setInputValue] = useState(initialSearchQuery || '');
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery || '');

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const triggerSearch = () => {
    if (inputValue.trim()) {
      setSearchQuery(inputValue.trim());
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      trackingNuvemDomainsSearch();
      triggerSearch();
    }
  };

  const handleBlur = () => {
    triggerSearch();
  };

  return {
    inputValue,
    searchQuery,
    handleSearchChange,
    handleKeyDown,
    handleBlur,
  };
}
